/* ============ EASE CASHMERE — THEME JS ============ */
(function(){
  'use strict';

  var EDITOR = !!(window.Shopify && window.Shopify.designMode);
  if (EDITOR) document.documentElement.classList.add('design-mode');

  /* ---- Header: transparent -> solid on scroll (home only) ---- */
  var hdr = document.getElementById('siteHeader');
  if (hdr && hdr.classList.contains('header') && !hdr.classList.contains('solid')) {
    var ticking = false;
    var updHeader = function(){
      var threshold = window.innerHeight * 0.7;
      if (window.scrollY > threshold) hdr.classList.add('scrolled');
      else hdr.classList.remove('scrolled');
      ticking = false;
    };
    window.addEventListener('scroll', function(){
      if(!ticking){ window.requestAnimationFrame(updHeader); ticking = true; }
    }, {passive:true});
    updHeader();
  }

  /* ---- Header: hide scrolling down, show scrolling up (desktop/tablet) ---- */
  (function(){
    var h = document.querySelector('.header');
    if (!h) return;
    var lastY = window.scrollY || 0;
    window.addEventListener('scroll', function(){
      if (window.innerWidth <= 768) { h.classList.remove('hdr-hide'); return; }
      var y = window.scrollY || 0;
      if (y <= 80) { h.classList.remove('hdr-hide'); lastY = y; return; }
      if (y > lastY + 4) { h.classList.add('hdr-hide'); }
      else if (y < lastY - 4) { h.classList.remove('hdr-hide'); }
      lastY = y;
    }, { passive: true });
  })();

  /* ---- Mobile floating logo: shows on scroll-up after hero ---- */
  var fl = document.getElementById('floatLogo');
  if (fl) {
    var last = 0, flTick = false;
    var onFlScroll = function(){
      var y = window.scrollY || window.pageYOffset;
      if (y > window.innerHeight * 0.6) {
        if (y < last) fl.classList.add('show');
        else fl.classList.remove('show');
      } else {
        fl.classList.remove('show');
      }
      last = y; flTick = false;
    };
    window.addEventListener('scroll', function(){
      if(!flTick){ window.requestAnimationFrame(onFlScroll); flTick = true; }
    }, {passive:true});
  }

  /* ---- Mobile drawer ---- */
  var drawer = document.getElementById('drawer');
  var mbMenu = document.getElementById('mbMenu');
  var drawerClose = document.getElementById('drawerClose');
  function drawerReset(){
    if (!drawer) return;
    var st = drawer.querySelector('.drawer-stage');
    if (st) st.classList.remove('sub-open');
    drawer.querySelectorAll('.drawer-sub').forEach(function(p){ p.classList.remove('is-active'); p.setAttribute('aria-hidden','true'); });
  }
  function drawerOpen(){
    if (!drawer) return;
    drawerReset();
    drawer.classList.add('open'); drawer.setAttribute('aria-hidden','false');
    if (mbMenu) mbMenu.setAttribute('aria-expanded','true');
    document.body.style.overflow = 'hidden';
  }
  function drawerShut(){
    if (!drawer) return;
    drawer.classList.remove('open'); drawer.setAttribute('aria-hidden','true');
    if (mbMenu) mbMenu.setAttribute('aria-expanded','false');
    document.body.style.overflow = '';
  }
  if (mbMenu && drawer) mbMenu.addEventListener('click', drawerOpen);
  if (drawerClose && drawer) drawerClose.addEventListener('click', drawerShut);
  if (drawer) drawer.addEventListener('click', function(e){
    var sub = e.target.closest('[data-drawer-sub]');
    if (sub){
      var panel = document.getElementById(sub.getAttribute('data-drawer-sub'));
      if (!panel) return;
      panel.classList.add('is-active'); panel.setAttribute('aria-hidden','false'); panel.scrollTop = 0;
      drawer.querySelector('.drawer-stage').classList.add('sub-open');
      var back = panel.querySelector('[data-drawer-back]'); if (back) back.focus({preventScroll:true});
      return;
    }
    if (e.target.closest('[data-drawer-back]')){ drawerReset(); return; }
  });

  /* ---- Desktop/tablet dropdown menu ---- */
  var hdrEl = document.getElementById('siteHeader');
  var ddItems = document.querySelectorAll('.nav-item.has-dd');
  var ddTimer = null;
  var noHover = window.matchMedia && window.matchMedia('(hover: none)').matches;
  function ddClose(except){
    ddItems.forEach(function(it){
      if (it === except) return;
      it.classList.remove('is-open');
      var a = it.querySelector('.navitem'); if (a) a.setAttribute('aria-expanded','false');
    });
    if (!except && hdrEl) hdrEl.classList.remove('menu-open');
  }
  function ddOpen(it){
    clearTimeout(ddTimer);
    ddClose(it);
    it.classList.add('is-open');
    var a = it.querySelector('.navitem'); if (a) a.setAttribute('aria-expanded','true');
    if (hdrEl){ hdrEl.classList.add('menu-open'); hdrEl.classList.remove('hdr-hide'); }
  }
  ddItems.forEach(function(it){
    it.addEventListener('mouseenter', function(){ if (!noHover) ddOpen(it); });
    it.addEventListener('mouseleave', function(){ if (!noHover){ clearTimeout(ddTimer); ddTimer = setTimeout(function(){ ddClose(); }, 160); } });
    it.addEventListener('focusin', function(){ ddOpen(it); });
    it.addEventListener('focusout', function(e){ if (!it.contains(e.relatedTarget)) ddTimer = setTimeout(function(){ if (!it.contains(document.activeElement)) ddClose(); }, 10); });
    var top = it.querySelector('.navitem');
    if (top) top.addEventListener('click', function(e){
      /* touch screens: first tap opens the dropdown, second tap follows the link */
      if (noHover && !it.classList.contains('is-open')){ e.preventDefault(); ddOpen(it); }
    });
  });
  document.addEventListener('click', function(e){
    if (ddItems.length && !e.target.closest('.nav-item.has-dd')) ddClose();
  });

  /* ---- Staged reveal: editor gets everything instantly, live gets the observer ---- */
  function initReveals(root){
    var scope = root && root.querySelectorAll ? root : document;
    var targets = scope.querySelectorAll('.stg, .reveal');
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (EDITOR || reduced || !('IntersectionObserver' in window)) {
      targets.forEach(function(el){ el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.2 });
    targets.forEach(function(el){ io.observe(el); });
  }
  initReveals(document);

  /* ---- Product rail: scrolls with page, sticks once fully shown ---- */
  function setRailTop(){
    var rail = document.querySelector('.pdp-info');
    if (!rail) return;
    if (window.innerWidth <= 900) { rail.style.removeProperty('--rail-top'); return; }
    var top = Math.min(90, window.innerHeight - rail.offsetHeight - 24);
    rail.style.setProperty('--rail-top', top + 'px');
  }
  setRailTop();
  window.addEventListener('resize', setRailTop);
  window.addEventListener('load', setRailTop);
  if (document.fonts && document.fonts.ready) { document.fonts.ready.then(setRailTop); }

  /* ---- Sticky reveal footer: above-footer bottom margin = footer height ---- */
  function setPad(){
    var rf = document.querySelector('.reveal-footer');
    var af = document.querySelector('.above-footer');
    if (!rf || !af) return;
    af.style.marginBottom = rf.offsetHeight + 'px';
  }
  setPad();
  window.addEventListener('resize', setPad);
  window.addEventListener('load', setPad);
  if (document.fonts && document.fonts.ready) { document.fonts.ready.then(setPad); }
  setTimeout(setPad, 300);
  setTimeout(setPad, 1000);

  /* ---- Collection stack: covered card dims and drifts as the next one slides over ---- */
  var csReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var csTick = false;
  function csUpdate(){
    csTick = false;
    var stacks = document.querySelectorAll('.cs');
    for (var s = 0; s < stacks.length; s++){
      var cards = stacks[s].querySelectorAll('.cs-card');
      for (var i = 0; i < cards.length; i++){
        if (i === cards.length - 1) { cards[i].style.setProperty('--p', '0'); continue; }
        var h = cards[i].offsetHeight || 1;
        var top = cards[i + 1].getBoundingClientRect().top;
        var p = Math.min(1, Math.max(0, 1 - top / h));
        cards[i].style.setProperty('--p', p.toFixed(4));
      }
    }
  }
  if (!csReduced && !EDITOR){
    window.addEventListener('scroll', function(){ if (!csTick){ csTick = true; requestAnimationFrame(csUpdate); } }, { passive: true });
    window.addEventListener('resize', csUpdate);
    csUpdate();
  }

  /* ---- Collection filter drawer ---- */
  function filterOpen(){
    var d = document.getElementById('filterDrawer'), o = document.getElementById('filterOverlay');
    if (!d) return;
    d.classList.add('open'); d.setAttribute('aria-hidden','false');
    if (o) o.classList.add('open');
    document.querySelectorAll('[data-filter-open]').forEach(function(b){ b.setAttribute('aria-expanded','true'); });
    document.body.style.overflow = 'hidden';
    var x = d.querySelector('.filter-x'); if (x) x.focus({preventScroll:true});
  }
  function filterShut(){
    var d = document.getElementById('filterDrawer'), o = document.getElementById('filterOverlay');
    if (!d || !d.classList.contains('open')) return;
    d.classList.remove('open'); d.setAttribute('aria-hidden','true');
    if (o) o.classList.remove('open');
    document.querySelectorAll('[data-filter-open]').forEach(function(b){ b.setAttribute('aria-expanded','false'); });
    document.body.style.overflow = '';
  }
  document.addEventListener('click', function(e){
    if (e.target.closest('[data-filter-open]')){ filterOpen(); return; }
    if (e.target.closest('[data-filter-close]')){ filterShut(); }
  });
  document.addEventListener('submit', function(e){
    if (!e.target.matches || !e.target.matches('#filterForm')) return;
    /* drop empty price fields so the URL stays clean */
    e.target.querySelectorAll('input[type="number"]').forEach(function(i){ if (i.value === '') i.disabled = true; });
  }, true);
  window.addEventListener('scroll', function(){
    if (!noHover && document.querySelector('.nav-item.is-open') && window.scrollY > 40) ddClose();
  }, {passive:true});

  /* ---- Blog embeds: .ease-bestsellers and .ease-banner, hydrated from live collection JSON ---- */
  function easeHandle(a){
    if (!a) return null;
    var m = (a.getAttribute('href') || '').match(/\/collections\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }
  function easeImg(src, w){
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function easeEsc(s){
    return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
    });
  }
  function easeMoney(v){
    var n = parseFloat(v);
    if (isNaN(n)) return '';
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
    try { return new Intl.NumberFormat('en-GB', {style:'currency', currency:cur}).format(n); }
    catch(e){ return '£' + n.toFixed(2); }
  }
  function easeBestsellers(el){
    var a = el.querySelector('a');
    var handle = easeHandle(a) || 'bestsellers';
    var url = (a && a.getAttribute('href')) || ('/collections/' + handle);
    var label = (a && a.textContent.trim()) || 'Shop all';
    fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=4')
      .then(function(r){ if (!r.ok) throw r; return r.json(); })
      .then(function(d){
        var ps = (d.products || []).slice(0, 4);
        if (!ps.length) return;
        var cards = ps.map(function(p){
          var imgs = p.images || [];
          var v = (p.variants || [])[0] || {};
          var i1 = imgs[0] ? '<img src="' + easeImg(imgs[0].src, 800) + '" srcset="' + easeImg(imgs[0].src, 500) + ' 500w, ' + easeImg(imgs[0].src, 800) + ' 800w" sizes="(max-width:767px) 50vw, 300px" alt="' + easeEsc(imgs[0].alt || p.title) + '" loading="lazy" decoding="async">' : '';
          var i2 = imgs[1] ? '<img src="' + easeImg(imgs[1].src, 800) + '" alt="" loading="lazy" decoding="async" aria-hidden="true">' : '';
          return '<a class="ease-bs-card" href="/products/' + encodeURIComponent(p.handle) + '">'
            + '<div class="ease-bs-img">' + i1 + i2 + '</div>'
            + '<div class="ease-bs-meta"><div class="n">' + easeEsc(p.title) + '</div><div class="p">' + easeMoney(v.price) + '</div></div></a>';
        }).join('');
        el.innerHTML = '<div class="ease-bs reveal stg"><div class="ease-bs-head"><h2>Bestsellers</h2>'
          + '<a class="ease-bs-all" href="' + easeEsc(url) + '">' + easeEsc(label) + '</a></div>'
          + '<div class="ease-bs-grid">' + cards + '</div></div>';
        initReveals(el);
      })
      .catch(function(){ /* keep the plain link */ });
  }
  function easeBanner(el){
    var a = el.querySelector('a');
    var handle = easeHandle(a);
    if (!handle) return;
    var url = a.getAttribute('href');
    var label = a.textContent.trim() || 'Shop the collection';
    fetch('/collections/' + encodeURIComponent(handle) + '.json')
      .then(function(r){ if (!r.ok) throw r; return r.json(); })
      .then(function(d){
        var c = d.collection || {};
        var src = c.image && c.image.src;
        var img = src ? '<img src="' + easeImg(src, 1600) + '" srcset="' + easeImg(src, 750) + ' 750w, ' + easeImg(src, 1100) + ' 1100w, ' + easeImg(src, 1600) + ' 1600w, ' + easeImg(src, 2200) + ' 2200w" sizes="100vw" alt="' + easeEsc((c.image && c.image.alt) || c.title || label) + '" loading="lazy" decoding="async">' : '';
        el.innerHTML = '<a class="ease-bn' + (src ? ' hero-fade stg' : ' no-img') + '" href="' + easeEsc(url) + '">' + img
          + '<span class="ease-bn-copy"><span class="ease-bn-title">' + easeEsc(label) + '</span><span class="ease-bn-cta">Discover</span></span></a>';
        initReveals(el);
      })
      .catch(function(){ /* keep the plain link */ });
  }
  document.querySelectorAll('.ease-bestsellers').forEach(easeBestsellers);
  document.querySelectorAll('.ease-banner').forEach(easeBanner);

  /* ---- Shopify theme editor: re-rendered sections must appear and work instantly ---- */
  ['shopify:section:load','shopify:section:reorder','shopify:section:select'].forEach(function(ev){
    document.addEventListener(ev, function(e){
      initReveals(e.target || document);
      setRailTop();
      setPad();
    });
  });

  /* ============ DELEGATED INTERACTIONS (survive editor re-renders) ============ */
  document.addEventListener('click', function(e){

    /* Card image carousel arrows */
    var cnav = e.target.closest('.cnav');
    if (cnav) {
      e.preventDefault(); e.stopPropagation();
      var gal = cnav.closest('.cardgal');
      if (!gal) return;
      gal.classList.add('cycled');
      var imgs = gal.querySelectorAll('.ci');
      if (imgs.length < 2) return;
      var idx = 0;
      imgs.forEach(function(im, i){ if (im.classList.contains('is-on')) idx = i; });
      var n = cnav.classList.contains('next') ? (idx + 1) % imgs.length : (idx - 1 + imgs.length) % imgs.length;
      imgs[idx].classList.remove('is-on');
      imgs[n].classList.add('is-on');
      return;
    }

    /* Accordions (product + collection faq styling variants) */
    var row = e.target.closest('.accordion .row');
    if (row) {
      row.classList.toggle('open');
      if (row.closest('.pdp-info')) setTimeout(setRailTop, 550);
      return;
    }
    var faqQ = e.target.closest('.faq-q');
    if (faqQ) { faqQ.parentElement.classList.toggle('open'); return; }

    /* Size selector */
    var sizeBtn = e.target.closest('.sizes button');
    if (sizeBtn) {
      var wrap = sizeBtn.closest('.sizes');
      wrap.querySelectorAll('button').forEach(function(x){ x.classList.remove('active'); });
      sizeBtn.classList.add('active');
      var input = document.getElementById('selected-variant');
      if (input && sizeBtn.dataset.variant) input.value = sizeBtn.dataset.variant;
      return;
    }

    /* Shop-the-look hotspots */
    var hs = e.target.closest('.hotspot');
    if (hs) {
      var sp = document.getElementById('shopPanel');
      var sov = document.getElementById('shopOverlay');
      if (!sp || !sov) return;
      var nameEl = document.getElementById('shopName');
      var priceEl = document.getElementById('shopPrice');
      var buyEl = document.getElementById('shopBuy');
      var thumbEl = document.getElementById('shopThumb');
      if (nameEl) nameEl.textContent = hs.dataset.name || '';
      if (priceEl) priceEl.textContent = hs.dataset.price || '';
      if (buyEl) buyEl.setAttribute('href', hs.dataset.url || '#');
      if (thumbEl && hs.dataset.img) thumbEl.style.backgroundImage = 'url(' + hs.dataset.img + ')';
      sp.classList.add('open'); sov.classList.add('open');
      document.body.style.overflow = 'hidden';
      return;
    }
    if (e.target.closest('#shopClose') || (e.target.id === 'shopOverlay')) {
      var sp2 = document.getElementById('shopPanel');
      var sov2 = document.getElementById('shopOverlay');
      if (sp2) sp2.classList.remove('open');
      if (sov2) sov2.classList.remove('open');
      document.body.style.overflow = '';
      return;
    }

    /* Size guide modal */
    if (e.target.closest('#sizeGuideBtn')) {
      var m = document.getElementById('sizeGuideModal');
      var o = document.getElementById('sizeGuideOverlay');
      if (m && o) { m.classList.add('open'); o.classList.add('open'); document.body.style.overflow = 'hidden'; }
      return;
    }
    if (e.target.closest('#sizeGuideClose') || (e.target.id === 'sizeGuideOverlay')) {
      var m2 = document.getElementById('sizeGuideModal');
      var o2 = document.getElementById('sizeGuideOverlay');
      if (m2) m2.classList.remove('open');
      if (o2) o2.classList.remove('open');
      document.body.style.overflow = '';
      return;
    }
    var tab = e.target.closest('.sg-tab');
    if (tab) {
      var g = tab.dataset.sg;
      document.querySelectorAll('.sg-tab').forEach(function(x){ x.classList.toggle('active', x === tab); });
      document.querySelectorAll('[data-sg-panel]').forEach(function(p){ p.style.display = p.dataset.sgPanel === g ? 'table' : 'none'; });
      return;
    }

    /* Wishlist (visual toggle) */
    var wl = e.target.closest('#addWishlist');
    if (wl) {
      wl.classList.toggle('active');
      wl.textContent = wl.classList.contains('active') ? 'Added to Wishlist' : 'Add to Wishlist';
      return;
    }

    /* Style It With quick add */
    var siw = e.target.closest('.siw-add');
    if (siw) {
      var vid = siw.dataset.variant;
      if (!vid) return;
      fetch('/cart/add.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:parseInt(vid,10),quantity:1})})
        .then(function(r){ return r.json(); })
        .then(function(){ cartFetch(); cartOpen(); });
      return;
    }

    /* Cart drawer close targets */
    if (e.target.closest('#cartClose') || e.target.closest('#cartContinue') || (e.target.id === 'cartOverlay')) {
      cartClose_();
      return;
    }
    var rm = e.target.closest('.cart-drawer-item .rm');
    if (rm) { cartChange(rm.dataset.key, 0); return; }
  });

  document.addEventListener('keydown', function(e){
    if (e.key !== 'Escape') return;
    ddClose(); drawerShut(); filterShut();
    ['shopPanel','shopOverlay','sizeGuideModal','sizeGuideOverlay','cartDrawer','cartOverlay'].forEach(function(id){
      var el = document.getElementById(id);
      if (el) el.classList.remove('open');
    });
    document.body.style.overflow = '';
  });

  /* ---- Cart drawer (element lives in layout, persists across section re-renders) ---- */
  function cartMoney(cents){ return '£' + (cents/100).toFixed(2); }
  function cartRender(cart){
    var body = document.getElementById('cartDrawerBody');
    var sub = document.getElementById('cartSubtotal');
    if (!body) return;
    if (!cart.items || cart.items.length === 0){
      body.innerHTML = '<div class="cart-drawer-empty">Your bag is empty.</div>';
    } else {
      var html = '';
      cart.items.forEach(function(item){
        html += '<div class="cart-drawer-item">'
          + '<div class="thumb" style="background-image:url(' + (item.image || '') + ')"></div>'
          + '<div class="meta"><div class="n">' + item.product_title + '</div>'
          + '<div class="v">' + (item.variant_title || '') + '</div>'
          + '<div class="p">' + cartMoney(item.final_line_price) + '</div>'
          + '<button class="rm" data-key="' + item.key + '">Remove</button></div></div>';
      });
      body.innerHTML = html;
    }
    if (sub) sub.textContent = cartMoney(cart.total_price);
    cartCount(cart.item_count);
  }
  function cartCount(n){
    document.querySelectorAll('.bag-count').forEach(function(el){
      el.textContent = n > 0 ? ' (' + n + ')' : '';
    });
  }
  function cartOpen(){
    var d = document.getElementById('cartDrawer'), o = document.getElementById('cartOverlay');
    if (d) d.classList.add('open');
    if (o) o.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function cartClose_(){
    var d = document.getElementById('cartDrawer'), o = document.getElementById('cartOverlay');
    if (d) d.classList.remove('open');
    if (o) o.classList.remove('open');
    document.body.style.overflow = '';
  }
  function cartFetch(){ fetch('/cart.js').then(function(r){ return r.json(); }).then(cartRender); }
  function cartChange(key, qty){
    fetch('/cart/change.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})})
      .then(function(r){ return r.json(); }).then(cartRender);
  }

  /* Product add-to-cart: delegated submit so re-rendered forms keep working */
  document.addEventListener('submit', function(e){
    var form = e.target;
    if (!form || !form.matches) return;
    if (!(form.matches('form[action$="/cart/add"]') || form.id === 'product-form' || (form.action || '').indexOf('/cart/add') !== -1)) return;
    if (!document.getElementById('cartDrawer')) return; /* no drawer: let it submit normally */
    e.preventDefault();
    var fd = new FormData(form);
    fetch('/cart/add.js', {method:'POST', body:fd})
      .then(function(r){ return r.json(); })
      .then(function(){ cartFetch(); cartOpen(); });
  });

  /* initial bag count */
  if (document.getElementById('cartDrawer')) {
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(c){ cartCount(c.item_count); }).catch(function(){});
  }

})();
